import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SPRACompetitionCsaRate } from 'src/app/Models/ops';
import { MasterService } from 'src/app/Services/master.service';

@Component({
  selector: 'app-spra-competition-csa-rate',
  templateUrl: './spra-competition-csa-rate.component.html',
  styleUrls: ['./spra-competition-csa-rate.component.css']
})
export class SpraCompetitionCsaRateComponent implements OnInit {
  public _SPRACompetitionCsaRate: Array<SPRACompetitionCsaRate>;  
constructor(
  private dialogRef: MatDialogRef <SpraCompetitionCsaRateComponent>,
  @Optional() @Inject(MAT_DIALOG_DATA) public data: Array<SPRACompetitionCsaRate>,
  private _MasterService: MasterService
) {
  this._SPRACompetitionCsaRate = new Array<SPRACompetitionCsaRate>();
  
}

ngOnInit(): void {
  this._MasterService.GetAllCounterList().subscribe((d) => {
    if (d) {
      let counterlist:any[]=[];
      counterlist = counterlist.concat(JSON.parse(JSON.stringify(d)));
      this._SPRACompetitionCsaRate = counterlist.map((c)=>{
        let SCCR:SPRACompetitionCsaRate = new SPRACompetitionCsaRate();
        SCCR.CounterId = c.counterId;
        SCCR.CounterDesc = c.counterDesc;       
        if(this.data !=undefined){
          SCCR.Rate = this.data.filter((csr)=>{ return csr.CounterId == SCCR.CounterId })[0].Rate
        }
        return SCCR;
      });

      
    }
  })

 

}



closeDialog(){
  let SelectedSPRACompetitionCsaRate: Array<SPRACompetitionCsaRate>;  
  // SelectedSPRACompetitionCsaRate = this._SPRACompetitionCsaRate.filter((cr) => { return (cr.Rate != undefined && cr.Rate >0) });
  this.dialogRef.close({ event: 'close', data: this._SPRACompetitionCsaRate });
}


}
